import React, { useEffect, useState } from "react";
import axios from "axios";
import NonWorkingInsert from "./NonWorkingInsert";
import { FaLessThanEqual } from "react-icons/fa";

const NonWorkingMaster = () => {
  const [active, setActive] = useState("insert");
  const [data, setData] = useState([]);
  const [machineData, setMachineData] = useState([]);
  const [section, setSection] = useState([]);
  const [reason, setReason] = useState([]);

  // console.log(section);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const fetchReason = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getTableDropDown`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.data;
        setReason(fetchedData);
      }
      setLoading(false);
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      setLoading(false);

      return [];
    }
  };

  useEffect(() => {
    fetchReason();
  }, []);
  const filteredReason = reason.filter((o) => o.tabel_path === "t_non_working");
  const fetchNonWorkingData = async () => {
    try {
      const response =
        await axios.get(`${urlBlockPrefix}getNonWorkingData?start=2022-01-25&end=2022-01-30 
`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.daterange.data;
        setData(fetchedData);
      }
      return [];
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      return [];
    }
  };

  const fetchSection = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getstationcode`);
      if (response.data.status === "ok") {
        const fetchedData = response.data.data;
        setSection(fetchedData);
      }
      setLoading(false);
    } catch (err) {
      console.error(`Failed to fetch stations for section:`, err);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSection();

    // fetchNonWorkingData();
  }, []);

  const fetchMachineData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${urlBlockPrefix}getmachinetype`);
      if (response.data.status === "ok") {
        const raw = response.data.machineTypes;
        const filtered = raw.filter((o) => o.DEPARTMENT === "ENGINEERING");
        const flattened = filtered.flatMap((o) =>
          o.children.flatMap((o) => o.children)
        );

        setMachineData(flattened);
      }
    } catch (err) {
      console.error("Failed to fetch machine types:", err);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMachineData();
  }, []);

  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "insert" && "active"
            }`}
          >
            Insert
          </button>
          {/* <button
            onClick={() => {
              setActive("update");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "update" && "active"
            }`}
          >
            Update
          </button> */}
          <hr />
        </div>
      </div>
      <div className="row">
        {active === "insert" ? (
          <div className="">
            <NonWorkingInsert
              data={data}
              machineData={machineData}
              section={section}
              loading={loading}
              filteredReason={filteredReason}
            />
          </div>
        ) : (
          <div className="">
            {/* <PathWastageUpdate /> */}UNDER DEVELOPMENT{" "}
          </div>
        )}
      </div>
    </div>
  );
};
export default NonWorkingMaster;
